module.exports = __webpack_public_path__ + "static/media/invoice_header.0819b129.jpg";